import React, { useState, useEffect, useContext } from "react";
import PopoverInput from "./inner/popoverInput.jsx";
import { DataSourceContext, IsMobileContext } from "../context/contexts.jsx";
 
const icon = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.00024 20H18.0002M3.8252 12.1661C3.5502 11.9661 3.3002 11.7161 3.00021 10.8411C2.91884 10.6241 2.61132 9.53619 2.35021 8.54109C2.12996 7.7017 1.9337 6.93555 2.02521 6.74109C2.10022 6.54109 2.2002 6.39109 2.5252 6.19109C2.7252 6.06802 3.7502 5.81609 3.9502 5.76609C4.1502 5.71609 4.42519 5.69109 4.6502 5.76609C5.0752 5.84109 5.9502 7.11609 6.1752 7.26609C6.27519 7.36609 6.6002 7.657 6.9752 7.69109C7.2502 7.71609 7.5252 7.64109 7.82521 7.51609C8.1002 7.40151 13.5252 4.76609 14.0252 4.54109C18.1002 2.84109 21.0602 5.63609 21.5102 6.23609C21.9752 6.81609 22.0752 6.99109 21.9502 7.49109C21.7886 8.01609 21.3502 8.11609 21.1002 8.19109C20.8502 8.26609 17.4002 9.19109 16.0502 9.56609C15.7553 9.6621 15.6113 9.85492 15.5752 9.89109C15.4002 10.1411 14.6052 11.8411 14.3802 12.2161C14.2252 12.6161 13.8002 13.1161 13.2502 13.3161C12.6752 13.5161 11.6752 13.7411 11.4502 13.8161C11.2252 13.8911 10.7002 14.0411 10.5252 13.9911C10.3002 13.9411 10.0852 13.7161 10.1852 13.3661C10.2852 13.0161 10.4752 12.0411 10.5002 11.8911C10.5252 11.7411 10.7752 11.1161 10.5002 11.0911C10.4502 11.0161 9.9252 11.2411 9.1502 11.4161C8.57442 11.5782 7.97143 11.7386 7.5502 11.8411C5.9252 12.3161 5.04514 12.4411 4.8502 12.4411C4.4752 12.4411 4.2002 12.3911 3.8252 12.1661Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"></path>
</svg>;
const DepartureFooter = ({ selectedAirports, close }) => {
    return <div className="text-center">
        <button className="btn bg-emp" onClick={() => close()}>Ok</button>
    </div>;
}
const SelectItem = ({ airportCode, airportName, isSelected, onChange }) => {
    return (<div className="form-checkbox-wrapper hover:bg-content_5 rounded-[8px] mr-2 text-content_2">
        <label className="form-checkbox-label-left ">
            <input type="checkbox" className="form-checkbox" checked={isSelected} onChange={() => onChange(airportCode, !isSelected)} />
            {airportName}
        </label>
    </div>)
}

const DeparturePicker = ({ selectedAirports, onUpdate, updateOverviewText }) => {
    const [availableDepAirs, setAvailableDepAirs] = useState(null);
    const [filterText, setFilterText] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const dataSource = useContext(DataSourceContext);
    const isMobile = useContext(IsMobileContext);

    useEffect(() => {
        async function fetchData() {
            setAvailableDepAirs(null)
            var departureAirports = await dataSource.getDepartures();
            setAvailableDepAirs(departureAirports);
        }
        fetchData();
    }, []);
    useEffect(() => {
        updateOverviewText(buildDepartureText());
    }, [selectedAirports, availableDepAirs]);


    const onDepartureChange = (code, isSelected) => {
        setFilterText("");
        if (isSelected) {
            onUpdate([...selectedAirports, code]);
        } else {
            var newAirportList = selectedAirports.filter((item) => item !== code);
            onUpdate(newAirportList);
         }

    }
    const buildDepartureText = () => {
        let inputText = "";
        //HasLoaded
        if (availableDepAirs) {

            var verifiedSelectedAir = [];
            for (let index = 0; index < selectedAirports.length; index++) {
                const myCode = selectedAirports[index];
                var found = availableDepAirs.find((item) => item.code == myCode);
                if (found) {
                    verifiedSelectedAir.push(found.name);
                }
            }

            if (verifiedSelectedAir.length == 1) {
                inputText = verifiedSelectedAir[0];
            } else if (verifiedSelectedAir.length > 1) {

                inputText = verifiedSelectedAir[0] + " +" + (verifiedSelectedAir.length - 1);

            } else {
                inputText = "Departing From";
            }

        } else {
            inputText = "Loading...";
        } return inputText;

    }

    const toggleAirports = (codes) => {
        var validCodes = [];
        if (areAllValidSelected(codes)) {
            //unselect
            validCodes = selectedAirports.filter((x) => !codes.includes(x));
        }
        else {
            var currentSelected = [...selectedAirports, ...codes.filter((x) => availableDepAirs.find((item) => item.code == x) || selectedAirports.includes(x))];
            currentSelected= [...new Set(currentSelected)];
            validCodes = currentSelected;
        }
        onUpdate(validCodes);
        updateOverviewText(buildDepartureText())
    }
    const areAllValidSelected = (codes) => {
        if (availableDepAirs) {
            var validCodes = codes.filter((x) => availableDepAirs.find((item) => item.code == x));

            return validCodes.every(element => selectedAirports.includes(element));
        }
        return false;
    }
    let filteredAirports = [];

    let inputText = "Departure Airport";
    if (availableDepAirs) {

        inputText = buildDepartureText();
        if (filterText) {
            filteredAirports = availableDepAirs.filter((item) => item.name.toLowerCase().includes(filterText.toLowerCase()) || item.code.toLowerCase() == filterText.toLowerCase());
        } else {
            filteredAirports = availableDepAirs;
        }
    }

    return <PopoverInput footer={<DepartureFooter selectAirports={selectedAirports} close={() => setIsOpen(false)} />} icon={icon} inputText={inputText} isLoading={availableDepAirs == null} onTextUpdate={setFilterText} filterText={filterText} doubleWidth={true} isOpen={isOpen} setIsOpen={setIsOpen}>
        <div className={"grid grid " + (isMobile ? "grid-cols-1" : "grid-cols-2")}>

            <div className="form-checkbox-wrapper hover:bg-content_5 rounded-[8px] mr-2 text-content_2">
                <label className="form-checkbox-label-left ">
                    <input type="checkbox" className="form-checkbox" checked={areAllValidSelected(["LGW", "STN", "LCY", "LHR", "LTN", "STN"])} onChange={() => toggleAirports(["LGW", "STN", "LCY", "LHR", "LTN", "STN"])} />
                    All London
                </label>
            </div>

            {filteredAirports?.map((x, i) => {
                return <SelectItem airportCode={x.code} airportName={x.name} key={i} isSelected={selectedAirports.includes(x.code)} onChange={onDepartureChange} />
            })}
        </div>
    </PopoverInput>
}
export default DeparturePicker;
